import { apiClient } from './client';
import { VendorAssessment, VendorAssessmentPayload } from '../types/vendorAssessment';

export interface AssessmentNoSuggestion {
  lastValue?: string | null;
  suggestedValue?: string | null;
}

export async function fetchVendorAssessments(
  vendorId: number,
  docType?: string
): Promise<VendorAssessment[]> {
  const { data } = await apiClient.get<VendorAssessment[]>('/part-vendor-assessments', {
    params: {
      vendorId,
      ...(docType ? { docType } : {}),
    },
  });
  return data;
}

export async function fetchVendorAssessment(assessmentId: number): Promise<VendorAssessment> {
  const { data } = await apiClient.get<VendorAssessment>(
    `/part-vendor-assessments/${assessmentId}`
  );
  return data;
}

export async function suggestVendorAssessmentNo(
  docType: string
): Promise<AssessmentNoSuggestion> {
  const { data } = await apiClient.get<AssessmentNoSuggestion>(
    '/part-vendor-assessments/suggestions/assessment-no',
    { params: { docType } }
  );
  return data;
}

export async function createVendorAssessment(
  payload: VendorAssessmentPayload
): Promise<VendorAssessment> {
  const { data } = await apiClient.post<VendorAssessment>('/part-vendor-assessments', payload);
  return data;
}

export async function updateVendorAssessment(
  assessmentId: number,
  payload: Partial<VendorAssessmentPayload>
): Promise<VendorAssessment> {
  const { data } = await apiClient.patch<VendorAssessment>(
    `/part-vendor-assessments/${assessmentId}`,
    payload
  );
  return data;
}

export async function deleteVendorAssessment(assessmentId: number): Promise<void> {
  await apiClient.delete(`/part-vendor-assessments/${assessmentId}`);
}
